const instances = new WeakMap();

export function setupStickyCheckout(root, environment = {}) {
  if (!root || instances.has(root)) return;
  const hostWindow = environment.window || window;
  const select = selector => root.querySelector(selector);
  if (root.dataset?.mmscLive === 'true') {
    hostWindow.addEventListener('pageshow', event => {
      // Back/Forward can restore an old empty or filled basket from memory.
      // Let Shopify render the current basket and discounted total afresh.
      if (event.persisted) hostWindow.location.reload();
    });
  }
  const cartForm = select('[data-mmsc-cart-form]');
  if (cartForm) {
    const cartButton = select('[data-mmsc-cart-button]');
    const pageForm = hostWindow.document?.getElementById('mm-cart-form') || hostWindow.document?.getElementById('cart');
    // Preserve unsaved quantity and order-note edits by using the native basket form.
    if (pageForm?.tagName === 'FORM') cartButton.setAttribute('form', pageForm.id);
    const checkoutForm = pageForm?.tagName === 'FORM' ? pageForm : cartForm;
    // The analytics module already observes the 2027 basket form.
    if (checkoutForm.id !== 'mm-cart-form') checkoutForm.addEventListener('submit', event => {
      if (event.submitter !== cartButton || cartButton.disabled) return;
      try { hostWindow.mmAnalytics?.capture('checkout_clicked'); }
      catch { /* Analytics must not interrupt native checkout. */ }
    });
    instances.set(root, true);
    return;
  }
  const ticket = select('[data-mmsc-ticket]');
  const link = select('[data-mmsc-ticket-link]');
  if (!ticket || !link) return;
  instances.set(root, true);
  function updateDestination() {
    const option = ticket.selectedOptions[0];
    let destination = '';
    if (option?.value && !option.disabled && option.dataset.productUrl) {
      try {
        const url = new URL(option.dataset.productUrl, hostWindow.location.href);
        if (url.origin === hostWindow.location.origin && /\/products\/[^/]+\/?$/.test(url.pathname)) destination = `${url.pathname}${url.search}${url.hash}`;
      } catch { /* Keep the ticket-section link if an option is unavailable. */ }
    }
    link.setAttribute('href', destination || link.dataset.defaultUrl);
    link.textContent = destination ? 'View ticket' : 'View tickets';
  }
  ticket.addEventListener('change', updateDestination);
  updateDestination();
}

if (typeof document !== 'undefined') {
  document.querySelectorAll('[data-mm-sticky-checkout]').forEach(root => setupStickyCheckout(root));
}
